import { small } from '../../../constants/fonts';

export default {
  container: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative',
    left: -15
  },
  chart: {
    top: 5,
    right: 20,
    left: 0,
    bottom: 15
  },
  xAxis: {
    left: 10,
    right: 10
  },
  tooltipText: {
    fontSize: small
  }
};
